import toastr from 'toastr'

import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import { loadStart, loadFinish, loadError } from 'common/redux/root'

const LOAD = 'support/LOAD'
const RESET = 'support/RESET'

const load = createAction(LOAD)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

const defaultLoadHandler = dispatch => response => {
  dispatch(load(response))
  dispatch(loadFinish())
  return Promise.resolve(response)
}

export function searchDispatchHash(dispatch_hash) {
  return dispatch => {
    return client.post('lead_by_dispatch_hash', {
      data: {
        dispatch_hash: dispatch_hash
      }
    })
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function searchZipcode(zipcode) {
  return dispatch => {
    dispatch(loadStart())
    // TODO: remove is_new_financing after client refresh
    return client.post('validate_zipcode', {
      data: {
        zipcode: zipcode,
        is_new_financing: true,
      }
    })
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function sendTestSMS(payload) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('send_test_sms', {
      data: payload
    })
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function generatePayrollPDFs(bucket, key, payroll_type, payperiod, date_range) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('generate_payroll_pdfs', {
        data: {
          bucket,
          key,
          payroll_type,
          payperiod,
          date_range
        }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function checkJobStatus(queue, job_id) {
  return dispatch => {
    return client.post('check_job_status', {
        data: {
          queue,
          job_id
        }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function prepareMassSMS(numbers, message) {
  return dispatch => {
    return client.post('prepare_mass_sms', {
        data: {
          numbers,
          message
        }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}


export function sendMassSMS(numbers, message) {
  return dispatch => {
    return client.post('send_mass_sms', {
        data: {
          numbers,
          message
        }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}


export function fetchPayrollRolesAndTeams() {
  return dispatch => {
    dispatch(clearPayperiods())
    return client.post('payroll_roles_and_teams', {})
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}


export function fetchPayperiods(key) {
  return dispatch => {
    dispatch(clearPayperiods())
    return client.post('payperiods', {
      data: {
        key
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function clearPayperiods() {
  return dispatch => {
    return dispatch(load({payroll_payperiods: null, payroll_reps: null}))
  }
}

export function fetchPayperiodReps(key, payperiod_id) {
  return dispatch => {
    return client.post('payperiod_reps', {
      data: {
        key,
        payperiod_id
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function processDBPayroll(key, payperiod_id) {
  return dispatch => {
    return client.post('process_db_payroll', {
      data: {
        key,
        payperiod_id
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function bulkGeneratePayrollInfo() {
  return dispatch => {
    return client.post('bulk_generate_payroll_info', {})
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function bulkGeneratePayroll(payperiod_id) {
  return dispatch => {
    return client.post('bulk_generate_payroll', {
      data: {
        payperiod_id
      }
    })
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function fetchFailedInquiries() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('failed_inquiry')
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function fetchOffCycleComp() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('fetch_off_cycle_comp')
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function reprocessFailedInquries(failed_ids) {
  return dispatch => {
    dispatch(loadStart())

    return client.post('reprocess_failed_inquiries', { data: {
            failed_inquiry_ids: failed_ids
          }
        }
      )
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function clearFailedInquiries(failed_ids) {
  return dispatch => {
    dispatch(loadStart())

    return client.post('clear_failed_inquiries', { data: {
            failed_inquiry_ids: failed_ids
          }
        }
      )
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function addLeadInquiry(payload, failed_inquiry_id) {
  return dispatch => {
    dispatch(loadStart())

    return client.post('add_lead_inquiry', { data: {
            failed_inquiry_id: failed_inquiry_id,
            ...payload
          }
        }
      )
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function startOffCycleComp(validation_rep_id, hours, overtime_hours, payperiod_id) {
  return dispatch => {
    return client.post('start_off_cycle_comp', {
      data: {
        validation_rep_id: validation_rep_id,
        hours: hours,
        overtime_hours: overtime_hours,
        payperiod_id: payperiod_id
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function processOffCycleComp(validation_rep_id, payperiod_id) {
  return dispatch => {
    return client.post('process_off_cycle_comp', {
      data: {
        validation_rep_id,
        payperiod_id
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function fetchAdminControlState() {
  return dispatch => {
    dispatch(load({isLoadingAdminState: true}))
    dispatch(loadStart())
    return client.post('fetch_admin_control_state')
      .then(response => {
        dispatch(load({isLoadingAdminState: false}))
        dispatch(load(response))
        dispatch(loadFinish())
      }).catch((response) => {
        dispatch(load({ isLoadingAdminState: false}))
        toastr.error(_.get(response, 'error.msg'))
      })
  }
}

export function updateBogotaLeadsSetting(target) {
  return dispatch => {
    dispatch(load({isLoadingAdminState: true}))
    dispatch(loadStart())
    return client.post('update_bogota_leads_setting', { data: { target }})
      .then(response => {
        dispatch(load({isLoadingAdminState: false}))
        dispatch(load(response))
        dispatch(loadFinish())
      }).catch((response) => {
        dispatch(load({ isLoadingAdminState: false}))
        toastr.error(_.get(response, 'error.msg'))
      })
  }
}

export function updateYonyxFallbackSetting(target) {
  return dispatch => {
    dispatch(load({isLoadingAdminState: true}))
    dispatch(loadStart())
    return client.post('update_yonyx_fallback_setting', { data: { target }})
      .then(response => {
        dispatch(load({isLoadingAdminState: false}))
        dispatch(load(response))
        dispatch(loadFinish())
      }).catch((response) => {
        dispatch(load({ isLoadingAdminState: false}))
        toastr.error(_.get(response, 'error.msg'))
      })
  }
}

const initialState = {}

export default handleActions({
  [LOAD]: (state, { payload }) => (Object.assign({}, state, {...payload})),
  [RESET]: (state, { payload }) => ({ ...initialState }),
}, initialState)
